import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

/**
 * Templated view for displaying submission details before user clicks 'submit'
 * @param {ReactElement} props.icon graphic to display next to title
 * @param {ReactElement} props.title label to display describing the form action
 * @param {ReactElement} props.contents information you want to display about the errors, contents, or submission status
 * @returns {ReactElement} component displaying information about the errors or the submission details
 */
const ReviewAndSubmitView = ({ icon, title, contents }) => {
	return (
		<Card variant='outlined' sx={{ minHeight: 150, m: 1, flexGrow: 1 }}>
			<CardContent>
				<Stack direction='row' alignItems='center' gap={1}>
					{icon}
					<Typography variant='h5' component='div'>
						{title}
					</Typography>
				</Stack>
				{contents}
			</CardContent>
		</Card>
	);
};

ReviewAndSubmitView.propTypes = {
	icon: PropTypes.element,
	title: PropTypes.string,
	contents: PropTypes.element,
};

export default ReviewAndSubmitView;
